var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalender(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 60,
    viewBox: "0 0 52 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_971_709)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.922 12.8574C34.2455 16.6369 30.4322 19.286 26 19.286C21.5678 19.286 17.7531 16.6369 16.078 12.8574H0V21.4289H52V12.8574H35.922Z",
    fill: "#64C8F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3333 60.0001H0V21.4287H52V51.4287L43.3333 60.0001Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 21.4287H4.33333V60.0001H0V21.4287Z",
    fill: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 12.8574H4.33333V21.4289H0V12.8574Z",
    fill: "#46AAD2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.333 51.4287V60.0001L51.9997 51.4287H43.333Z",
    fill: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.33301 11.7856V17.1427H6.49967V11.7856C6.49967 11.1936 6.98447 10.7141 7.58301 10.7141C8.18155 10.7141 8.66634 11.1936 8.66634 11.7856V12.857H10.833V11.7856C10.833 10.0097 9.37863 8.57129 7.58301 8.57129C5.78738 8.57129 4.33301 10.0097 4.33301 11.7856Z",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.167 11.7856V17.1427H43.3337V11.7856C43.3337 11.1936 43.8185 10.7141 44.417 10.7141C45.0155 10.7141 45.5003 11.1936 45.5003 11.7856V12.857H47.667V11.7856C47.667 10.0097 46.2126 8.57129 44.417 8.57129C42.6214 8.57129 41.167 10.0097 41.167 11.7856Z",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5 25.7139H23.8333V29.9996H19.5V25.7139Z",
    fill: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.167 25.7139H32.5003V29.9996H28.167V25.7139Z",
    fill: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.833 25.7139H41.1663V29.9996H36.833V25.7139Z",
    fill: "#FA6450"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.833 34.2861H15.1663V38.5718H10.833V34.2861Z",
    fill: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5 34.2861H23.8333V38.5718H19.5V34.2861Z",
    fill: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.167 34.2861H32.5003V38.5718H28.167V34.2861Z",
    fill: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.833 34.2861H41.1663V38.5718H36.833V34.2861Z",
    fill: "#FA6450"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.833 42.8574H41.1663V47.1431H36.833V42.8574Z",
    fill: "#FA6450"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.833 42.8574H15.1663V47.1431H10.833V42.8574Z",
    fill: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5 42.8574H23.8333V47.1431H19.5V42.8574Z",
    fill: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.167 42.8574H32.5003V47.1431H28.167V42.8574Z",
    fill: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.833 51.4287H15.1663V55.7144H10.833V51.4287Z",
    fill: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5 51.4287H23.8333V55.7144H19.5V51.4287Z",
    fill: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.167 51.4287H32.5003V55.7144H28.167V51.4287Z",
    fill: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9997 17.1429C30.7861 17.1429 34.6663 13.3053 34.6663 8.57143C34.6663 3.83756 30.7861 0 25.9997 0C21.2132 0 17.333 3.83756 17.333 8.57143C17.333 13.3053 21.2132 17.1429 25.9997 17.1429Z",
    fill: "#FA6450"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4997 8.57143C19.4997 4.20134 22.8093 0.602679 27.083 0.0736607C26.7282 0.0294643 26.3667 0 25.9997 0C21.214 0 17.333 3.83839 17.333 8.57143C17.333 13.3045 21.214 17.1429 25.9997 17.1429C26.3667 17.1429 26.7282 17.1134 27.083 17.0692C22.8093 16.5415 19.4997 12.9415 19.4997 8.57143Z",
    fill: "#DC4632"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 14.9997C29.5899 14.9997 32.5 12.1216 32.5 8.57115C32.5 5.02075 29.5899 2.14258 26 2.14258C22.4101 2.14258 19.5 5.02075 19.5 8.57115C19.5 12.1216 22.4101 14.9997 26 14.9997Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1663 9.10756H25.458V4.28613H26.5413V8.03613H28.1663V9.10756Z",
    fill: "#505050"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_971_709"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalender);
export default __webpack_public_path__ + "static/media/Calender.77b1dc80fcf4718dc9fd9d57b6cbb2d5.svg";
export { ForwardRef as ReactComponent };